import { Api } from '../api';
import { auth } from '../endpoints';
import type { ApiResponse } from '../../models';
import type { AuthenticateRequest, AuthTokenResponse, RefreshTokenRequest } from './models';

export class AuthApi extends Api {
  static authenticate = async (request: AuthenticateRequest) => {
    const result = await this.post<AuthenticateRequest, ApiResponse<AuthTokenResponse>>({ url: auth.authenticate(), data: request });
    return result.data;
  };

  static refreshToken = async (token: string) => {
    const result = await this.post<RefreshTokenRequest, ApiResponse<AuthTokenResponse>>({ url: auth.refreshToken(), data: { refreshToken: token } });
    if (!result.data?.refreshToken) result.data!.refreshToken = token;
    return result.data!;
  };
}
